module.exports = __webpack_public_path__ + "img/poker-h05.84274a56.svg";